import React from 'react'
import { Image } from '@/atoms/Image'
import { InternalLink } from '@/atoms/InternalLink'
import { LinkViewModel } from '@/services/RenderService'
import { useSafeTrack } from '@/utils/analytics'

interface LargeLandscapeLinkProps {
  link: LinkViewModel
  imageWidth?: number
  imageHeight?: number
}

export function LargeLandscapeLink({ link, imageWidth = 490, imageHeight = 294 }: LargeLandscapeLinkProps) {
  const track = useSafeTrack()
  const handleClick = React.useCallback(() => {
    if (link.track) track(link.track?.eventName, link.track?.payload)
  }, [link.track, track])

  if (!link.imageUrl) return null

  return (
    <InternalLink
      href={link.linkUrl}
      aria-label={`project-tile-${link.name}`}
      className="block h-fit transform-gpu transition-transform duration-300 ease-in-out [backface-visibility:hidden] group-hover/rail:will-change-transform hover:z-10 md:hover:scale-[1.03]"
      onClick={handleClick}
    >
      <Image
        aria-label={link.alt}
        alt={link.alt}
        src={link.imageUrl}
        height={imageHeight}
        width={imageWidth}
        className="rounded-lg bg-black"
      />
    </InternalLink>
  )
}
